/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { AlertCondition } from './AlertCondition';
import {
    AlertConditionFromJSON,
    AlertConditionFromJSONTyped,
    AlertConditionToJSON,
    AlertConditionToJSONTyped,
} from './AlertCondition';

/**
 * 
 * @export
 * @interface AlertRuleResponse
 */
export interface AlertRuleResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    machinePartId?: string;
    /**
     * 
     */
    sectionType?: AlertRuleResponseSectionTypeEnum;
    /**
     * 
     */
    questionMatch?: string;
    /**
     * 
     */
    condition?: AlertCondition;
    /**
     * 
     */
    severity?: AlertRuleResponseSeverityEnum;
    /**
     * 
     */
    active?: boolean;
    /**
     * 
     */
    notifyRoles?: Array<string>;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const AlertRuleResponseSectionTypeEnum = {
    StatusCheck: 'STATUS_CHECK',
    NumberEntry: 'NUMBER_ENTRY',
    TextResult: 'TEXT_RESULT',
    MultiValue: 'MULTI_VALUE',
} as const;
export type AlertRuleResponseSectionTypeEnum = typeof AlertRuleResponseSectionTypeEnum[keyof typeof AlertRuleResponseSectionTypeEnum];

/**
 * @export
 */
export const AlertRuleResponseSeverityEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Critical: 'CRITICAL',
} as const;
export type AlertRuleResponseSeverityEnum = typeof AlertRuleResponseSeverityEnum[keyof typeof AlertRuleResponseSeverityEnum];


/**
 * Check if a given object implements the AlertRuleResponse interface.
 */
export function instanceOfAlertRuleResponse(value: object): value is AlertRuleResponse {
    return true;
}

export function AlertRuleResponseFromJSON(json: any): AlertRuleResponse {
    return AlertRuleResponseFromJSONTyped(json, false);
}

export function AlertRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertRuleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'sectionType': json['sectionType'] == null ? undefined : json['sectionType'],
        'questionMatch': json['questionMatch'] == null ? undefined : json['questionMatch'],
        'condition': json['condition'] == null ? undefined : AlertConditionFromJSON(json['condition']),
        'severity': json['severity'] == null ? undefined : json['severity'],
        'active': json['active'] == null ? undefined : json['active'],
        'notifyRoles': json['notifyRoles'] == null ? undefined : json['notifyRoles'],
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function AlertRuleResponseToJSON(json: any): AlertRuleResponse {
    return AlertRuleResponseToJSONTyped(json, false);
}

export function AlertRuleResponseToJSONTyped(value?: AlertRuleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'sectionType': value['sectionType'],
        'questionMatch': value['questionMatch'],
        'condition': AlertConditionToJSON(value['condition']),
        'severity': value['severity'],
        'active': value['active'],
        'notifyRoles': value['notifyRoles'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

